import { ReactElement, ReactNode } from 'react'
import styled from 'styled-components'
import { defaultTheme } from '../../../../../../src/theme'

interface ResultsBarButtonProps {
  children: ReactNode
  onClick?: () => void
  disabled?: boolean
  type?: 'button' | 'submit'
  'aria-label'?: string
  useDefaultIconColor?: boolean
}

export const ResultsBarButton = ({
  children,
  onClick,
  disabled,
  type = 'button',
  'aria-label': ariaLabel,
  useDefaultIconColor = false,
}: ResultsBarButtonProps): ReactElement => (
  <Button
    type={type}
    onClick={onClick}
    disabled={disabled}
    aria-label={ariaLabel}
    $useDefaultIconColor={useDefaultIconColor}
  >
    {children}
  </Button>
)

const Button = styled.button<{ $useDefaultIconColor: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 100%;
  padding: 19px 16px;
  background: transparent;
  border: none;
  border-left: 1px solid #d3d2cf;
  border-radius: 0;
  font-family: Oswald, serif;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  text-transform: uppercase;
  color: ${defaultTheme.colors.black};
  cursor: pointer;
  white-space: nowrap;

  & .MuiSvgIcon-root {
    color: ${(p) =>
      p.$useDefaultIconColor ? defaultTheme.colors.black : '#adadaa'};
    font-size: 20px;
  }

  &:hover:not(:disabled) {
    background: #ebebeb;
  }

  &:focus-visible {
    outline: 2px dashed ${defaultTheme.colors.black};
    outline-offset: -2px;
  }

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }

  @media screen and (max-width: 767px) {
    padding: 10px 10px;
    font-family: Roboto, serif;
    font-size: 14px;
    text-transform: capitalize;
  }
`
